var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import icons from '@sanity/icons';
import { createElement, forwardRef } from 'react';
export var Icon = forwardRef(function (props, ref) {
  var symbol = props.symbol,
      restProps = __rest(props, ["symbol"]);

  if (!icons[symbol]) {
    return null;
  }

  return createElement(icons[symbol], Object.assign(Object.assign({}, restProps), {
    ref: ref
  }));
});
Icon.displayName = 'Icon';